export const FIRST_PAGE = 1;
export const MAX_VISIBLE = 5;
export const MAX_VISIBLE_SMALL_RANGE = 4;

export const PREV_CAPTION = 'Prev';
export const NEXT_CAPTION = 'Next';
export const NUMBER_CAPTION = 'Number';
